import optionsFromStrings from "./optionsFromStrings.js";
import defaults from "../options/defaults.js";
function getOptionsFromElement(element) {
  var options = {};
  for (var property in defaults) {
    if (defaults.hasOwnProperty(property)) {
      if (element.hasAttribute("jsbarcode-" + property.toLowerCase())) {
        options[property] = element.getAttribute("jsbarcode-" + property.toLowerCase());
      }
      if (element.hasAttribute("data-" + property.toLowerCase())) {
        options[property] = element.getAttribute("data-" + property.toLowerCase());
      }
    }
  }
  options["value"] = element.getAttribute("jsbarcode-value") || element.getAttribute("data-value");
  options = optionsFromStrings(options);
  return options;
}
var stdin_default = getOptionsFromElement;
export {
  stdin_default as default
};
